<div class="logo">
  <img src="assets/general/logo.png" />
  <p>بنتو</p>
</div>
<p class="title">نام خود را وارد کنید</p>
<div
  [ngClass]="
    name && name.split.length > 1 ? 'input-box active' : 'input-box disable'
  "
>
  <span class="input-focuse" *ngIf="!!isFocuse"> نام</span>
  <img
    class="phone-image"
    *ngIf="!isFocuse"
    src="assets/authentication/user.svg"
  />
  <input
    type="text"
    id="phoneInput"
    [placeholder]="isFocuse ? '' : '*نام'"
    [(ngModel)]="name"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (ngModelChange)="activateButton($event)"
  />
  <div class="icons">
    <img
      *ngIf="name && name.split.length > 1"
      src="assets/authentication/close.svg"
      (click)="clearInput()"
      alt=""
    />
  </div>
</div>
<p class="require-message">*این فیلد الزامی است.</p>
